import { Dispatch } from "redux";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { getFileApi } from "../api/fileApi";

export const GET_FILE = "GET_FILE";
export const GET_FILE_SUCCESS = "GET_FILE_SUCCESS";
export const GET_FILE_FAILURE = "GET_FILE_FAILURE";

export const getFile = (
  dispatch: Dispatch,
  params: string | undefined,
  config: AxiosRequestConfig
) => {
  dispatch({ type: GET_FILE });
  getFileApi(params, config)
    .then((response: AxiosResponse) => {
      dispatch({
        type: GET_FILE_SUCCESS,
        status: response.status,
        filename: response.data.filename,
        signedUrl: response.data.signed_url,
      });
    })
    .catch((error: AxiosError) => {
      dispatch({
        type: GET_FILE_FAILURE,
        status: error.response?.status,
      });
    });
};
